/**
 * 规范化入口 HTML，用于忽略首尾空白导致的无意义差异。
 *
 * @param {string} html 入口页面响应内容
 * @returns {string} 可稳定比较的入口内容
 */
function normalizeEntryHtml(html) {
    return (html || '').trim()
}

/**
 * 判断入口 HTML 是否发生变化，入口文件变化通常代表静态资源版本已更新。
 *
 * @param {string} previousHtml 首次记录的入口内容
 * @param {string} latestHtml 最新请求到的入口内容
 * @returns {boolean} 是否检测到新版本
 */
function hasEntryVersionChanged(previousHtml, latestHtml) {
    const previous = normalizeEntryHtml(previousHtml)
    const latest = normalizeEntryHtml(latestHtml)
    return previous !== '' && latest !== '' && previous !== latest
}

/**
 * 为入口文件请求追加时间戳参数，避免浏览器或中间缓存返回旧内容。
 *
 * @param {string} url 入口文件地址
 * @param {number} timestamp 当前时间戳
 * @returns {string} 带缓存穿透参数的检测地址
 */
function createVersionCheckUrl(url, timestamp) {
    const separator = url.indexOf('?') === -1 ? '?' : '&'
    return `${url}${separator}_version_check=${timestamp}`
}

module.exports = {
    normalizeEntryHtml,
    hasEntryVersionChanged,
    createVersionCheckUrl,
}
